import * as React from 'react';

import { ChevronLeft } from 'lucide-react';
import { PaginationLink } from './pagination-link';

export const PaginationPrevious = (
    props: React.ComponentProps<typeof PaginationLink>,
) => (
    <PaginationLink aria-label="Go to previous page" type="previous" {...props}>
        <ChevronLeft />
    </PaginationLink>
);

PaginationPrevious.displayName = 'PaginationPrevious';
